// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const SoftwareObservationSourceTypeSchema = z.enum(['SERVICE_DETECTION','HTTP_PROBE','SOFTWARE_ENUMERATION','USER_PROVIDED','EXTERNAL_INTEGRATION'] as const);

export type SoftwareObservationSourceTypeType = `${z.infer<typeof SoftwareObservationSourceTypeSchema>}`

export default SoftwareObservationSourceTypeSchema;
